import { useMutation } from '@tanstack/react-query';
import Api from '../api/Api';
import { CreateReportData } from '../api/endpoints/Service';
import { MUTATION_KEYS } from './queryKeys';

type UseCreateReportMutationOptions = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export default function useCreateReportMutation({
  onSuccess,
  onError,
}: UseCreateReportMutationOptions) {
  return useMutation({
    mutationKey: [MUTATION_KEYS.report.createReport],
    mutationFn: async (payload: CreateReportData): Promise<void> => {
      await Api.service.createReport(payload);
    },
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      console.error('Error creating report:', error);
      onError?.(error);
    },
  });
}
